// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__27DI6","info":"UpdateTermsInfo_info__1EASo"};